import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import { token } from '@atlaskit/tokens';

import { getUseCaseIcon } from '@atlassian/rovo-conversation-actions/prompt-use-case-icons';
import type { PromptCard } from '@atlassian/rovo-conversation-actions/prompt-cards';
import {
	HandleActionType,
	type ConversationAction,
} from '@atlassian/rovo-conversation-actions/types';

export const EMPTY_PAGE_CREATION_PROMPT_IDS = [
	'create-product-requirements-document',
	'create-customer-onboarding-strategy',
	'create-background-research-plan',
] as const;

/* istanbul ignore next */
const styles = cssMap({
	iconContainer: {
		padding: token('space.075'),
	},
});

export const getEmptyPageCreationActions = (promptCards: PromptCard[]): ConversationAction[] => {
	const promptCardsById = new Map(promptCards.map((card) => [card.id, card]));

	return EMPTY_PAGE_CREATION_PROMPT_IDS.reduce<ConversationAction[]>((actions, targetId) => {
		const card = promptCardsById.get(targetId);

		if (card) {
			actions.push({
				handleType: HandleActionType.Chat,
				id: card.id,
				title: card.title,
				dynamicPrompt: card.prompt,
				icon: () => {
					const Icon = getUseCaseIcon(card.useCase);
					return (
						<Flex alignItems="center" justifyContent="center" xcss={styles.iconContainer}>
							<Icon />
						</Flex>
					);
				},
			});
		}

		return actions;
	}, []);
};
